import request from '@/utils/request';

export function fetchNots(query) {
  return request({
    url: `https://viaglobal.pl/api//${process.env.VUE_APP_API_NOTIF_URL}`,
    method: 'get',
    params: query,
  });
}

